import React from 'react'

interface IconProps {
    width?: number | string
    height?: number | string
    className?: string
}

export const CreditCardIcon: React.FC<IconProps> = ({ width = 16, height = 16, className = '' }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth='1.5'
            stroke='currentColor'
            className={className}
        >
            <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z'
            />
        </svg>
    )
}

export const WalletIcon: React.FC<IconProps> = ({ width = 16, height = 16, className = '' }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            fill='currentColor'
            viewBox='0 0 16 16'
            className={className}
        >
            <path d='M0 3a2 2 0 0 1 2-2h13.5a.5.5 0 0 1 0 1H15v2a1 1 0 0 1 1 1v8.5a1.5 1.5 0 0 1-1.5 1.5h-12A2.5 2.5 0 0 1 0 12.5zm1 1.732V12.5A1.5 1.5 0 0 0 2.5 14h12a.5.5 0 0 0 .5-.5V5H2a2 2 0 0 1-1-.268M1 3a1 1 0 0 0 1 1h12V2H2a1 1 0 0 0-1 1' />
        </svg>
    )
}

export const BankIcon: React.FC<IconProps> = ({ width = 16, height = 16, className = '' }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            fill='currentColor'
            viewBox='0 0 16 16'
            className={className}
        >
            <path d='m8 0 6.61 3h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.38l.5 2a.498.498 0 0 1-.485.62H.5a.498.498 0 0 1-.485-.62l.5-2A.5.5 0 0 1 1 13V6H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 3h.89zM3.777 3h8.447L8 1zM2 6v7h1V6zm2 0v7h2.5V6zm3.5 0v7h1V6zm2 0v7H12V6zM13 6v7h1V6zm2-1V4H1v1zm-.39 9H1.39l-.25 1h13.72z' />
        </svg>
    )
}

export const ApplePayIcon: React.FC<IconProps> = ({ width = 16, height = 16, className = '' }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            fill='currentColor'
            viewBox='0 0 16 16'
            className={className}
        >
            <path d='M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282' />
        </svg>
    )
}

export const GooglePayIcon: React.FC<IconProps> = ({ width = 16, height = 16, className = '' }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            viewBox='0 0 20 20'
            className={className}
            fill='currentColor'
        >
            <path
                d='M18.0234 8.45703C18.0234 7.88068 17.973 7.34115 17.8721 6.82842H10.127V9.25848H14.5942C14.4095 10.0599 13.8835 10.7109 13.0942 11.1416V12.8437H15.6415C17.0962 11.614 18.0234 10.1846 18.0234 8.45703Z'
                fill='currentColor'
            />
            <path
                d='M10.127 15.9949C12.313 15.9949 14.1588 15.3438 15.6415 12.8437L13.0942 11.1416C12.4174 11.5723 11.4902 11.8519 10.127 11.8519C7.98503 11.8519 6.16748 10.4478 5.58577 8.5293H2.96045V10.292C4.44321 13.6074 7.1665 15.9949 10.127 15.9949Z'
                fill='currentColor'
            />
            <path
                d='M5.58577 8.5293C5.42627 7.98975 5.33618 7.42896 5.33618 6.84727C5.33618 6.26557 5.42627 5.70478 5.58577 5.16523V3.40233H2.96045C2.36816 4.61667 2 5.95747 2 6.84727C2 7.73706 2.36816 9.07788 2.96045 10.292L5.58577 8.5293Z'
                fill='currentColor'
            />
            <path
                d='M10.127 3.8335C11.3853 3.8335 12.5024 4.26416 13.3925 5.04962L15.6415 2.9062C14.1588 1.56541 12.3129 0.833984 10.127 0.833984C7.1665 0.833984 4.44321 3.22141 2.96045 6.53687L5.58577 8.29977C6.16748 6.3813 7.98503 3.8335 10.127 3.8335Z'
                fill='currentColor'
            />
        </svg>
    )
}

export const PayPalIcon: React.FC<IconProps> = ({ width = 16, height = 16, className = '' }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            viewBox='0 0 16 16'
            className={className}
            fill='currentColor'
        >
            <path d='M14.062 4.703c.071-.261.11-.535.11-.821C14.172 1.75 12.185 0 9.761 0H3.914a.548.548 0 0 0-.541.461L1.336 12.141a.33.33 0 0 0 .325.379h2.372l-.066.375a.327.327 0 0 0 .325.375h2.285a.546.546 0 0 0 .541-.456l.022-.121.433-2.746.028-.151a.547.547 0 0 1 .541-.457h.34c2.208 0 3.941-1.137 4.444-3.426.21-.98.101-1.805-.434-2.379a1.857 1.857 0 0 0-.535-.531c.13.1.26.211.382.333.425.426.618 1.056.505 1.816-.005.026-.01.053-.016.08' />
            <path d='M13.014 4.378l.144-.09.05-.163c.207-.763.014-1.593-.588-2.195a2.252 2.252 0 0 0-.335-.258h-.006A2.945 2.945 0 0 0 11.414 1.4c-.025-.003-.051-.01-.077-.013a3.27 3.27 0 0 0-.549-.044H7.011a.735.735 0 0 0-.252.044.535.535 0 0 0-.349.415l-.836 5.291-.025.15c.028-.177.18-.309.363-.309H8.13c2.207 0 3.94-1.136 4.444-3.425a2.82 2.82 0 0 0 .441-.935' />
        </svg>
    )
}
